import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { handleToastMessage } from "src/js/handleToastMessage";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "src/firebase/firebase";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required."),
  lastName: Yup.string().required("Last name is required."),
  email: Yup.string().email().trim().required("Email is required."),
  password: Yup.string().required("Password is required."),
  confirmPassword: Yup.string().required("Confirm Password is required."),
});
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const NewProcessing = () => {
  const { t } = useTranslation(["home"]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const addProcessingTeam = (values: any) => {
    setIsLoading(true);
    createUserWithEmailAndPassword(auth, values.email, values.password)
      .then((userCredential) => {
        handleProcessingTeam(values);
      })
      .catch((error) => {
        setIsLoading(false);
        switch (error.code) {
          case "auth/email-already-in-use":
            handleToastMessage("error", "Email already in use");
            break;
          default:
            break;
        }
        // ..
      });
  };

  const handleProcessingTeam = async (values: any) => {
    setIsLoading(true);
    let _user = values;
    delete _user.password;
    delete _user.confirmPassword;
    _user.id = uuidv4();
    _user.accountType = "processing team";
    _user.date = new Date();
    _user.isEnable = true;
    await setDoc(doc(db, "Accounts", _user.id), _user);
    setIsLoading(false);
    handleToastMessage("success", "Suppli created successfully.");
    navigate("/admin/processing-management");
  };
  return (
    <>
      <div className="p-5">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl text-darkBlack font-semibold">
            {t("Processing")} {t("Management")}
          </h2>

          <div className="flex gap-x-2">
            <h4
              className="cursor-pointer"
              onClick={() => navigate("/admin/processing-management")}
            >
              {" "}
              {t("Processing")} {t("Management")} /
            </h4>
            <span className="text-grey">Add {t("Processing")}</span>
          </div>
        </div>
        <div className="pb-4 bg-white">
          <h2 className="text-xl text-darkBlack font-semibold py-2 px-5 border-b">
            Add {t("Processing")}
          </h2>
          <div className="p-5">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={addProcessingTeam}
              validateOnBlur
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                handleBlur,
                handleChange,
                isSubmitting,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="p-2">
                      <div className="flex gap-4">
                        <Input
                          label="First Name"
                          className="flex-1"
                          placeholder="First Name"
                          name="firstName"
                          error={errors.firstName}
                          touched={touched.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="solid"
                        />
                        <Input
                          label="Last Name"
                          className="flex-1"
                          placeholder="Last Name"
                          name="lastName"
                          error={errors.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.lastName}
                          variant="solid"
                        />
                      </div>
                      <div className="flex gap-4">
                        <Input
                          labelClassName="mt-3 text-base font-medium inline-block"
                          label="Password"
                          className="flex-1"
                          placeholder="Password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="password"
                          type="password"
                          error={errors.password}
                          touched={touched.password}
                          variant="solid"
                        />
                        <Input
                          labelClassName="mt-3 text-base font-medium inline-block"
                          label="Confirm Password"
                          className="flex-1"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.confirmPassword}
                          touched={touched.confirmPassword}
                          variant="solid"
                        />
                      </div>
                      <Input
                        label="Email ID"
                        containerClass="w-full"
                        placeholder="Email"
                        name="email"
                        error={errors.email}
                        touched={touched.email}
                        value={values.email}
                        onChange={(e) => {
                          const value = e.target.value || "";
                          setFieldTouched("email", true);
                          setFieldValue("email", value.toLowerCase());
                        }}
                        onBlur={handleBlur}
                        variant="solid"
                      />
                    </div>
                    <div className="flex justify-end">
                      <Button
                        className="ml-0 block  bg-blue mt-4 mb-3"
                        loading={isLoading}
                        type="submit"
                      >
                        Add
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};
export default NewProcessing;
